import { render, staticRenderFns } from "./MyTextBox.vue?vue&type=template&id=1e12b6d5&scoped=true&"
import script from "./MyTextBox.vue?vue&type=script&lang=js&"
export * from "./MyTextBox.vue?vue&type=script&lang=js&"
import style0 from "./MyTextBox.vue?vue&type=style&index=0&id=1e12b6d5&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e12b6d5",
  null
  
)

export default component.exports